import styled from "styled-components";
import { useTranslation } from "react-i18next";

type TModalProps = {
  modalTitle?: string;
  isOpen: boolean;
  onClose: () => void;
};

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
`;

const ModalWrap = styled.div`
  position: relative;
  width: 960px;
  height: 380px;
  background: white;
  padding: 40px;
  border-radius: 10px;
  margin: 30px;
  @media (max-width: 550px) {
    height: 60%;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  width: 30px;
  height: 30px;
  top: 10px;
  right: 10px;
  color: white;
  border: none;
  font-size: 0.85rem;
  font-weight: 700;
  background: #971b2f;
  border-radius: 50%;
  cursor: pointer;
`;
const ContentWrap = styled.div`
  display: flex;
  gap: 60px;
  margin-top: 20px;
  @media (max-width: 550px) {
    flex-wrap: wrap;
    gap: 0;
  }
`;
const TitleWrap = styled.div`
  width: 50%;
  height: 100%;
  @media (max-width: 550px) {
    width: 100%;
  }
`;
const Title = styled.p`
  font-size: 2.6rem;
  font-weight: 700;
  color: #971b2f;
  font-weight: bold;
  margin-bottom: 20px;
  @media (max-width: 1000px) {
    font-size: 2rem;
  }
`;
const Subtitle = styled.p`
  font-size: 1.8rem;
  margin-bottom: 20px;
  @media (max-width: 1000px) {
    font-size: 1.5rem;
  }
`;
const FormWrap = styled.div`
  width: 60%;
  @media (max-width: 550px) {
    width: 100%;
  }
`;
const Form = styled.div`
  display: flex;
  gap: 0 15px;
  flex-wrap: wrap;
`;
const Input = styled.input`
  width: 195px;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;
  @media (max-width: 550px) {
    width: 100%;
  }
`;

const CheckboxWrap = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

const Checkbox = styled.input`
  margin-right: 10px;
`;

const SubmitButton = styled.button`
  position: absolute;
  bottom: 80px;
  right: 50px;
  width: 157px;
  background-color: #27262b;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-weight: bold;
  @media (max-width: 1000px) {
    position: static;
  }
`;

export default function DownloadModal({ isOpen, onClose, modalTitle }: TModalProps) {
  const { t } = useTranslation();
  if (!isOpen) return null;
  return (
    <Overlay>
      <ModalWrap>
        <CloseButton onClick={onClose}>✖</CloseButton>
        <ContentWrap>
          <TitleWrap>
            <Title>{modalTitle}</Title>
            <Subtitle>{t("menu.learn.result.download-modal.sub-title")}</Subtitle>
          </TitleWrap>
          <FormWrap>
            <Form>
              <Input type="text" placeholder={t("menu.learn.result.download-modal.input.name")} />
              <Input type="email" placeholder={t("menu.learn.result.download-modal.input.email")} />
              <Input type="tel" placeholder={t("menu.learn.result.download-modal.input.phone")} />
              <CheckboxWrap>
                <Checkbox type="checkbox" id="communication" />
                <label htmlFor="communication">{t("menu.learn.result.download-modal.communication")}</label>
              </CheckboxWrap>
              <CheckboxWrap>
                <Checkbox type="checkbox" id="privacy" />
                <label htmlFor="privacy">{t("menu.learn.result.download-modal.privacy")}</label>
              </CheckboxWrap>
            </Form>
            <SubmitButton>{t("menu.learn.result.download-modal.get-my-copy")} ↗</SubmitButton>
          </FormWrap>
        </ContentWrap>
      </ModalWrap>
    </Overlay>
  );
}
